const state = {
    data: [],
    submitOptions: {
        property_types: [],
        conditions: [],
        objectives:[]
    }
}
export default state;